import React from "react";
import "./IkoDescription.styles.scss";

const IkoDescription = () => {
  return (
    <div className="iko-description-div">
      <h1 className="iko-page-heading">IKO</h1>
      <p className="iko-page-text">
        NOD Bearings Pvt. Ltd. are the authorised distributors for IKO bearings.
      </p>
    </div>
  );
};

export default IkoDescription;
